import { useInput } from "react-admin";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../quill-custom.css";
import React, { useMemo } from 'react';

// 🔹 sanitizer function
const sanitizeQuillValue = (val) => {
  if (!val) return "";

  return val
    .replace(/<span class="ql-cursor">.*?<\/span>/g, "") // hapus marker cursor
    .replace(/<p><br><\/p>$/g, "") // hapus paragraf kosong di akhir
    .replace(/<p>\s*<\/p>/g, ""); // hapus semua paragraf kosong
};

const MyRichTextInput = (props) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useInput(props);

  const cleanValue = sanitizeQuillValue(value);

  const modules = useMemo(() => ({
            toolbar: {
                container: [
                    [{ header: [1, 2, false] }],
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                    ['link', 'image'],
                    ['clean'],
                ],
                
            },
            clipboard: {
                matchVisual: false,
            },
        }), []);

  return (
    <div style={{ width: "100%", marginBottom: "1rem" }}>
      <p class="MuiTypography-root MuiTypography-body1 RaLabeled-label css-k16oju-MuiTypography-root" style={{fontSize:"0.75em"}}><span>Content</span></p>
      <ReactQuill
        theme="snow"
         value={cleanValue}
        onChange={(content) => onChange(sanitizeQuillValue(content))}
        modules={modules}
      />
      {error && <span style={{ color: "red" }}>{error.message}</span>}
    </div>
  );
};

export default MyRichTextInput;
